import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/BeritaDetail.css'; // Tempatkan CSS Anda di file ini
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import api from '../services/api';

const BeritaDetail = () => {
  const { id } = useParams(); // ambil parameter dari URL
  const [berita, setBerita] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  function formatTanggalIndo(isoDateStr) {
    const bulanIndo = [
      'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
      'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
    ];

    const tanggal = new Date(isoDateStr);
    const day = tanggal.getDate();
    const month = bulanIndo[tanggal.getMonth()];
    const year = tanggal.getFullYear();

    return `${day} ${month} ${year}`;
  }
  const fetchData = useCallback(async () => {
  setLoading(true);
  setError('');
  try {
    const response = await api.getBerita(id);
    setBerita(response);
  } catch (err) {
    setError('Gagal memuat data LSP');
  } finally {
    setLoading(false);
  }
}, [id]); // tergantung `id` agar tidak infinite loop
  useEffect(() => {
  fetchData();
}, [fetchData]);

  if (!berita) return <div className="container">Memuat...</div>;

  return (
    <>
      <Navbar />
      <div className="container">
        <Link to="/berita" className="back-link">&larr; Kembali ke daftar berita</Link>
        {error && <div className="text-red-600 mb-4">{error}</div>}
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <h1 className="news-title">{berita.judul}</h1>

            <div className="news-meta">
              Dipublikasikan pada {formatTanggalIndo(berita.updatedAt)} | Oleh <strong>{berita.user ? berita.user.fullName : ''}</strong>
            </div>

            <img src={`${process.env.REACT_APP_BACKEND_URL}/public/upload/${berita.gambar.filename}`} alt={berita.judul} className="news-image" />

            <div className="news-content">
              <p>{berita.isi}</p>
            </div>

            <div className="share-buttons">
              <span>Bagikan:</span>
              <a href={`https://www.facebook.com/sharer/sharer.php?u=https://contohwebsite.com/berita/${id}`} target="_blank" rel="noreferrer">
                <button>Facebook</button>
              </a>
              <a href={`https://twitter.com/intent/tweet?url=https://contohwebsite.com/berita/${id}&text=${encodeURIComponent(berita.judul)}`} target="_blank" rel="noreferrer">
                <button>Twitter</button>
              </a>
              <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(berita.judul)} https://contohwebsite.com/berita/${id}`} target="_blank" rel="noreferrer">
                <button>WhatsApp</button>
              </a>
            </div>
          </>)}

      </div>
      <Footer />
    </>
  );
};

export default BeritaDetail;
